@if (tabla.filter ? tabla.filter.length > 0 : false) {
    <!-- Filtros básicos -->
    <app-filter [filtros]="filtrosBasicos" (changeInput)="filter($event)" [showClearButton]="!mostrarFiltrosAvanzados" />
    
    <!-- Botón de búsqueda avanzada -->
    @if (filtrosAvanzados.length > 0) {
        <div class="flex justify-end mt-3 mb-2">
            <button 
                type="button" 
                class="advanced-search-btn"
                [class.active]="mostrarFiltrosAvanzados"
                (click)="toggleFiltrosAvanzados()">
                <i class="pi" [ngClass]="mostrarFiltrosAvanzados ? 'pi-angle-up' : 'pi-search'"></i>
                {{ mostrarFiltrosAvanzados ? 'Ocultar filtros avanzados' : 'Búsqueda avanzada' }}
            </button>
        </div>
    }
    
    <!-- Filtros avanzados (colapsables) -->
    @if (mostrarFiltrosAvanzados && filtrosAvanzados.length > 0) {
        <div class="advanced-filters-container">
            <h6 class="advanced-filters-title">Filtros Avanzados</h6>
            <app-filter [filtros]="filtrosAvanzados" (changeInput)="filter($event)" [showClearButton]="true" />
        </div>
    }
}
@if (tabla.excel) {
    <div class="flex w-full justify-end mt-2">
        <button class="py-3 px-5 text-sm font-medium rounded-lg transition-all duration-200 bg-excel-100 hover:bg-excel-200 text-white flex justify-center items-center" (click)="generateXlsx()">
            <i class="pi pi-download mr-2"></i>
            {{ 'Descargar listado (formato XLSX)' }}
        </button>
    </div>
}
@if (tabla.rowsPerPageOptions ? tabla.rowsPerPageOptions.length > 0 : false) {
    <div class="flex justify-center items-center w-full mt-2">
        <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rows]="rows"
            class="flex-1"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="tabla.rowsPerPageOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            dropdownAppendTo="body"
        />
    </div>
}

<p-table #table [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '10rem' }" styleClass="mt-2" [value]="data" [loading]="loading" dataKey="id" (onSort)="onSort($event)">
    <ng-template pTemplate="header">
        <tr class="dark-tr">
            <!-- Preguntamos si marco como casillas seleccionables -->
            @if (tabla.selectable) {
                <th style="width: 20px">
                    <div style="display: flex; justify-content: start; align-items: center">
                        <app-checkbox #principal etiqueta="" (click)="otherAction = hasSelectedAll = true" (valorChange)="checkAll($event)" />
                    </div>
                </th>
            }
            @for (item of tabla.table; track $index) {
                @if (item.sortable) {
                    <th [pSortableColumn]="item.property ? item.property.toString() : ''">
                        <div style="display: flex; justify-content: start; align-items: center">
                            {{ item.nombre }}
                            <p-sortIcon [field]="item.property ? item.property.toString() : ''" />
                        </div>
                    </th>
                } @else {
                    <th style="text-align: center !important">{{ item.nombre }}</th>
                }
            }
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-i>
        <tr (click)="onRowSelect(i)" class="item">
            <!-- Preguntamos si marco como casillas seleccionables -->
            @if (tabla.selectable) {
                <td style="width: 20px">
                    <div style="display: flex; justify-content: start; align-items: center">
                        <app-checkbox #check etiqueta="" (click)="otherAction = selectedOne = true" (valorChange)="checkItem(i, $event)" />
                    </div>
                </td>
            }
            @for (item of tabla.table; track $index) {
                <!-- Si no es un botón, solo pasamos las propiedades -->
                @if (!item.buttons) {
                    <!-- Caso que sean fechas -->
                    @if (item.isDate) {
                        <td
                            pTooltip="{{
                                returnData(i, item.property, item.subProperty!)
                                    ? (returnData(i, item.property, item.subProperty!) | date: (item.hasTime ? (item.formatDate ?? 'dd/MM/yyyy HH:mm') : (item.formatDate ?? 'dd/MM/yyyy')))
                                    : 'No Aplica'
                            }}"
                            [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
                            [class]="item.cssClass"
                            tooltipPosition="bottom"
                        >
                            {{
                                returnData(i, item.property, item.subProperty!)
                                    ? (returnData(i, item.property, item.subProperty!) | date: (item.hasTime ? (item.formatDate ?? 'dd/MM/yyyy HH:mm') : (item.formatDate ?? 'dd/MM/yyyy')))
                                    : 'No Aplica'
                            }}
                        </td>
                        <!-- Caso que sean valores booleanos -->
                    } @else if (item.isBoolean) {
                        <!-- Las clases se aplican dependiendo si le pasaron el cssClass, sino aplica el true o false class -->
                        <td [pTooltip]="item.booleanValue(i)" [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }" [class]="item.cssClass ? item.cssClass : item.booleanClass(i)" tooltipPosition="bottom">
                            {{ item.booleanValue(i) }}
                        </td>
                        <!-- Caso que sea un array lo que hay que mostrar -->
                    } @else if (item.isArray) {
                        <td *ngIf="item.isArray" [class]="item.cssClass" [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }" tooltipPosition="bottom">
                            <ng-container *ngIf="item.valueFn; else legacyArray">
                                <span *ngIf="!isArray(item.valueFn(i))" [pTooltip]="item.valueFn(i) || 'No Aplica'">{{ item.valueFn(i) || 'No Aplica' }}</span>
                                <div *ngIf="isArray(item.valueFn(i))" class="hx-pill-group">
                                    <ng-container *ngFor="let v of item.valueFn(i)">
                                        <span *ngIf="!v?.class" class="hx-pill" [pTooltip]="v?.tooltip || v?.raw || v?.view || 'No Aplica'" tooltipPosition="bottom">{{ v?.view || v }}</span>
                                        <span *ngIf="v?.class" [class]="v.class" class="hx-pill" [pTooltip]="v?.tooltip || v?.raw || v?.view || 'No Aplica'" tooltipPosition="bottom">{{ v?.view || v?.raw || v }}</span>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #legacyArray>
                                <span [pTooltip]="returnDataArray(i, item.property, item.subProperty!) || 'No Aplica'">
                                    {{ returnDataArray(i, item.property, item.subProperty!) || 'No Aplica' }}
                                </span>
                            </ng-template>
                        </td>
                    } @else {
                        <!-- Caso común -->
                        <td
                            [pTooltip]="returnData(i, item.property, item.subProperty!) ? returnData(i, item.property, item.subProperty!) : 'No Aplica'"
                            [class]="item.cssClass"
                            [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
                            tooltipPosition="bottom"
                        >
                            {{ returnData(i, item.property, item.subProperty!) != undefined ? returnData(i, item.property, item.subProperty!) : 'No Aplica' }}
                        </td>
                    }
                    <!-- Caso contrario, creamos el botón -->
                } @else {
                    <td>
                        <div class="w-full flex justify-center items-center">
                            @for (button of item.buttons; track $index) {
                                @if (button.shouldRender === 'always') {
                                    @if (button.type === 'radio') {
                                        <p-inputSwitch [(ngModel)]="button.checked" (ngModelChange)="otherAction = true; button.fx(i, $event)" />
                                    } @else {
                                        <div pRipple [classList]="button.class" [pTooltip]="button.text" tooltipPosition="left" [tooltipDisabled]="button.primeIcon ? false : true" (click)="otherAction = true; button.fx(i)">
                                            @if (button.primeIcon) {
                                                <i class="pi {{ button.primeIcon }}"></i>
                                            } @else {
                                                <p>{{ button.text }}</p>
                                            }
                                        </div>
                                    }
                                } @else if (button.conditionValue(i)) {
                                    @if (button.type === 'radio') {
                                        <p-inputSwitch [ngModel]="button?.checked(i) || false" (onChange)="otherAction = true; button.fx(i, $event.checked)" />
                                    } @else {
                                        <div pRipple [classList]="button.class" [pTooltip]="button.text" tooltipPosition="left" [tooltipDisabled]="button.primeIcon ? false : true" (click)="otherAction = true; button.fx(i)">
                                            @if (button.primeIcon) {
                                                <i class="pi {{ button.primeIcon }}"></i>
                                            } @else {
                                                <p>{{ button.text }}</p>
                                            }
                                        </div>
                                    }
                                }
                            }
                        </div>
                    </td>
                }
            }
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            @if (tabla.selectable) {
                <td style="width: 20px"><p-skeleton width="1rem" height="1rem"></p-skeleton></td>
            }
            @for (item of tabla.table; track $index) {
                <td><p-skeleton width="100%" height="1rem"></p-skeleton></td>
            }
        </tr>
    </ng-template>
</p-table>

@if (tabla.rowsPerPageOptions ? tabla.rowsPerPageOptions.length > 0 : false) {
    <div class="flex justify-center items-center w-full mt-2">
        <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rows]="rows"
            class="flex-1"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="tabla.rowsPerPageOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            dropdownAppendTo="body"
        />
    </div>
}
